module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_14.5f5d496e.png";